import { render, staticRenderFns } from "./VacancyCard.vue?vue&type=template&id=22382a20"
import script from "./VacancyCard.vue?vue&type=script&lang=js"
export * from "./VacancyCard.vue?vue&type=script&lang=js"
import style0 from "./VacancyCard.vue?vue&type=style&index=0&id=22382a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports